<div class="d-flex mt-2 row">
    <mat-form-field appearance="outline" class="col-md-4">
      <mat-label>Enter week date range</mat-label>
      <mat-date-range-input [rangePicker]="picker">
        <input matStartDate [(ngModel)]="startDate1" placeholder="Start date">
        <input matEndDate [(ngModel)]="endDate1" placeholder="End date" (dateChange)="onEndDateChanged()">
      </mat-date-range-input>
      <mat-hint>DD/MM/YYYY – DD/MM/YYYY</mat-hint>
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-date-range-picker #picker></mat-date-range-picker>
    </mat-form-field>

<!--    <mat-form-field appearance="outline" class="col-md-6">-->
<!--      <mat-label>Select Centre</mat-label>-->
<!--      <mat-select #selectElement  [(ngModel)]="selectedCentreCode" multiple>-->
<!--        <app-select-all [matSelect]="selectElement"></app-select-all>-->
<!--        <mat-option  *ngFor=" let c of (centres$|async) "  [value]="c.centreCode">{{c.centreName}} </mat-option>-->
<!--      </mat-select>-->
<!--    </mat-form-field>-->

  <app-searchable-select
    class="col-md-4"
    [options]="centres$ | async"
    [selectedValue]="selectedCentre"
    [displayWithFn]="displayCentre"
    [placeholder]="'Select Centre'"
    [label]="'Select Centre'"
    [multiple]="true"
    (selectionChange)="onCentreSelect($event)">
  </app-searchable-select>


  <div class="col-md-2">
    <button mat-mini-fab (click)="SearchData()" color="accent">
      <mat-icon>search</mat-icon>
    </button>
    <button mat-mini-fab (click)="clearAll()" color="accent" style="margin-left: 10px;">
      <mat-icon>clear</mat-icon>
    </button>
  </div>
</div>

<div class="mb-2">
  <button mat-stroked-button [color]="viewMode === 'daily' ? 'primary' : undefined" (click)="viewMode = 'daily'">Daily</button>
  <button mat-stroked-button class="ms-2" [color]="viewMode === 'monthly' ? 'primary' : undefined" (click)="viewMode = 'monthly'">Month wise</button>
</div>

<div class="d-flex flex-wrap" *ngIf="viewMode === 'monthly'">
  <mat-card class="col-md-12 col-sm-12 mb-4 monthly-report">
    <div class="d-flex justify-content-end">
      <div class="export-button" matTooltip="XLSX" (click)="exportMonthlyExcel()">
        <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
      </div>
    </div>
    <div class="text-center mb-3">
      <h2 class="mb-1">Occupancy Average Data (Month wise)</h2>
      <div *ngIf="startDate1 && endDate1">{{startDate1|date:'dd/MM/yyyy'}} - {{endDate1|date:'dd/MM/yyyy'}}</div>
    </div>
    <p *ngIf="!yearlySummary.length" class="text-center">No data. Select a date range and centre, then search.</p>
    <div *ngFor="let y of yearlySummary" class="mb-4">
      <div class="text-center mb-2">
        <h3 class="mb-0">Calendar Year- {{y.year}}</h3>
        <div>Total Strength of facilities - {{y.units}} Units</div>
      </div>
      <table class="table table-bordered text-center align-middle">
        <thead>
        <tr><th>Sr No.</th><th>Month</th><th>Occupied</th><th>Total Occupancy</th><th>Available</th><th>Percentage</th></tr>
        </thead>
        <tbody>
        <tr *ngFor="let r of y.rows; let i = index">
          <td>{{i + 1}}</td>
          <td>{{r.month}}<div *ngIf="r.partialTill" class="small">({{r.partialTill}})</div></td>
          <td>{{r.occupied}}</td>
          <td>{{r.totalOccupancy}}</td>
          <td>{{r.available}}</td>
          <td>{{r.percentage | number:'1.0-2'}}%</td>
        </tr>
        </tbody>
      </table>
    </div>
  </mat-card>
</div>

<div class="d-flex flex-wrap" *ngIf="viewMode === 'daily'">
  <mat-card class="col-md-12 col-sm-12 mb-4">
 <div class="ngxTableHeader">
      <ul class="header-buttons-left ms-0 mb-0">
        <li class="dropdown">
          <h2>Occupancy Report <span *ngIf="startDate1">{{startDate1|date:'dd/MM/yyyy'}}</span><span *ngIf="endDate1">  -  {{endDate1|date:'dd/MM/yyyy'}}</span></h2>
        </li>
        <li class="dropdown m-l-20">
          <label for="search-input"><i class="material-icons search-icon">search</i></label>
          <input placeholder="Search" type="text" id="search-input" class="browser-default search-field"
                 (keyup)='applyFilter($event)' aria-label="Search box" #input>
        </li>
      </ul>
      <ul class="header-buttons mr-2">

        <li>
          <div  class="export-button m-l-10" matTooltip="XLSX" (click)="exportexcel()" permission="Occupancy Report" [permissionTypes]="[PermissionType.ALL, PermissionType.EXCEL]" >
            <img src="../../../../../assets/images/icons/xlsx.png" alt="" />
          </div>
        </li>
      </ul>
    </div>
    <table mat-table [dataSource]="dataSource" matSort id="occupancyReportTable">
          <!-- Sr Column -->
          <ng-container matColumnDef="Sr">
            <th mat-header-cell *matHeaderCellDef> Sr.No. </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{ i + 1 }} </td>
            <td mat-footer-cell *matFooterCellDef>  </td>
          </ng-container>

          <!-- Centre Name Column -->
          <ng-container matColumnDef="centreName">
            <th mat-header-cell *matHeaderCellDef> Centre Name </th>
            <td mat-cell *matCellDef="let element"> {{ getCentreNameByCode(element.centreCode)}} </td>
            <td mat-footer-cell *matFooterCellDef>  </td>
          </ng-container>

          <!-- Available Column -->
          <ng-container matColumnDef="available">
            <th mat-header-cell *matHeaderCellDef> Available (Vacant) Unit</th>
            <td mat-cell *matCellDef="let element"> {{ element.available }} </td>
            <td mat-footer-cell *matFooterCellDef> <strong>{{ getTotal('available') }}</strong> </td>
          </ng-container>

          <!-- Date Column -->
          <ng-container matColumnDef="date">
            <th mat-header-cell *matHeaderCellDef> Date </th>
            <td mat-cell *matCellDef="let element"> {{ element.date.toDate() | date:'dd/MM/yyyy' }} </td>
            <td mat-footer-cell *matFooterCellDef> <strong>Total : </strong></td>
          </ng-container>

          <!-- Occupied Column -->
          <ng-container matColumnDef="occupied">
            <th mat-header-cell *matHeaderCellDef> Total Occupied </th>
            <td mat-cell *matCellDef="let element"> {{ element.occupied }} </td>
            <td mat-footer-cell *matFooterCellDef> <strong>{{ getTotal('occupied') }}</strong> </td>
          </ng-container>

          <!-- Total Occupancy Column -->
          <ng-container matColumnDef="totalOccupancy">
            <th mat-header-cell *matHeaderCellDef> Total Occupancy per Night </th>
            <td mat-cell *matCellDef="let element"> {{ element.totalOccupancy }} </td>
            <td mat-footer-cell *matFooterCellDef> <strong>{{ getTotal('totalOccupancy') }}</strong> </td>
          </ng-container>

          <!-- Percentage Column -->
          <ng-container matColumnDef="percentage">
            <th mat-header-cell *matHeaderCellDef> Occupancy Percentage </th>
            <td mat-cell *matCellDef="let element">{{ (element.occupied / element.totalOccupancy) * 100 | number:'1.0-2' }}%</td>
            <td mat-footer-cell *matFooterCellDef><strong>{{ getTotalPercentage() | number: '1.0-2' }}%</strong></td>
          </ng-container>
      <!-- Table Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="selectedRow(row)"></tr>
      <tr mat-footer-row *matFooterRowDef="getFooterColumns()"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[25, 50, 100,200]" aria-label="Select page of users"></mat-paginator>
  </mat-card>

  <div class=" mt-4 col-md-12 mb-5 height-auto ">
    <!--        <app-financial-report-table></app-financial-report-table>-->
  </div>
</div>
